<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="item in tabMapOptions"
        :key="item.key"
        :label="item.label"
        :name="item.key"
      >
        <!-- <keep-alive> -->
        <component
          :is="activeName"
          :contractNo="contractNo"
          v-if="activeName === item.key"
          :ref="item.key"
        />
        <!-- </keep-alive> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Producer from './components/Producer/index.vue';
  import MaterialQuality from './components/MaterialQuality/index.vue';
  import Package from './components/Package/index.vue';
  import Norms from './components/Norms/index.vue';
  import Manufacturer from './components/Manufacturer/index.vue';
  import Category from './components/Category/index.vue';

  export default {
    name: 'receivables',
    components: {
      Producer,
      MaterialQuality,
      Package,
      Norms,
      Manufacturer,
      Category,
    },
    data() {
      return {
        activeName: 'Producer',
        contractNo: '',
        tabMapOptions: [
          { label: '产地', key: 'Producer' },
          { label: '材质', key: 'MaterialQuality' },
          { label: '包装', key: 'Package' },
          { label: '规格', key: 'Norms' },
          { label: '厂商', key: 'Manufacturer' },
          { label: '类目', key: 'Category' },
        ],
      };
    },
    mounted() {
      // if (this.$route?.query.status == 'leaseContract') {
      //   console.log('接受参数', this.$route?.query);
      //   this.activeName = 'ParkProperty';
      //   this.contractNo = this.$route?.query.contractNo;
      // }
      // this.$nextTick(() => {
      //   if (
      //     [
      //       '供应链运输事业部',
      //       '广西物产桂储物流有限公司',
      //       '广西物产供应链管理有限公司',
      //       '柳州市桂中海迅运输有限公司',
      //       '广西桂物通物流有限公司',
      //       '广西物产桂储物流有限公司成都分公司',
      //       '广西物产桂储物流有限公司天津分公司',
      //     ].includes(this.userInfo.companyName)
      //   ) {
      //     this.activeName = 'MultimodalTransport';
      //   } else {
      //     this.activeName = 'Trade';
      //   }
      // });
    },
    watch: {
      // $route: {
      //   handler: function (newValue) {
      //     if (newValue && newValue.query && newValue.query.contractNo) {
      //       setTimeout(() => {
      //         this.activeName = 'ParkProperty';
      //       }, 20);
      //     }
      //   },
      //   immediate: true,
      // },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-tabs__header {
      margin: 0px !important;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      border-bottom: none;
      background: #fff;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      background: #ebf3fe;
      border-bottom: 1px solid #e4e7ed;
    }
  }
</style>
